import React from 'react';
import styles from './Tabs.module.css';

const variants = {
  underline: styles.underline,
  pills: styles.pills,
};

export default function Tabs({ children, variant = 'underline', className = '', ...rest }) {
  return (
    <div className={`${styles.tabs} ${variants[variant] || styles.underline} ${className}`} {...rest}>
      {children}
    </div>
  );
}

Tabs.Tab = function Tab({ active, children, onClick, className = '', ...rest }) {
  return (
    <button
      className={`${styles.tab} ${active ? styles.active : ''} ${className}`}
      onClick={onClick}
      {...rest}
    >
      {children}
    </button>
  );
};
